export const SECTOR_COUNT = 10;
export const HOMEWORLD_REGION = 11;
